var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPaystack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    height: 612,
    id: "svg_12",
    width: 612,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_11)",
    fill: "#0BA4DB",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m548.42,0l-516.63,0c-17.48,0 -31.79,14.33 -31.79,31.85l0,57.34c0,17.51 14.31,31.85 31.79,31.85l515.04,0c17.48,0 31.79,-14.34 31.79,-31.85l0,-57.34c1.59,-17.52 -12.72,-31.85 -30.2,-31.85zm0,320.11l-516.63,0c-17.48,0 -31.79,14.33 -31.79,31.85l0,57.34c0,17.52 14.31,31.85 31.79,31.85l515.04,0c17.48,0 31.79,-14.34 31.79,-31.85l0,-57.34c1.59,-17.52 -12.72,-31.85 -30.2,-31.85zm-225.73,160.85l-290.9,0c-17.48,0 -31.79,14.34 -31.79,31.86l0,57.33c0,17.52 14.31,31.85 31.79,31.85l290.9,0c17.49,0 31.79,-14.33 31.79,-31.85l0,-57.33c0,-17.52 -14.3,-31.86 -31.79,-31.86zm257.52,-320.11l-548.42,0c-17.48,0 -31.79,14.34 -31.79,31.85l0,57.34c0,17.52 14.31,31.85 31.79,31.85l548.42,0c17.48,0 31.79,-14.33 31.79,-31.85l0,-57.34c0,-17.51 -14.31,-31.85 -31.79,-31.85z",
    id: "svg_2"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,0l612,0l0,602l-612,0l0,-602z",
    fill: "#fff",
    id: "svg_3"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("use", {
    id: "svg_13",
    transform: "matrix(0.829306 0 0 0.850267 -1.46503 0.0548629)",
    x: 313.15,
    y: 0.02,
    xlinkHref: "#svg_12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaystack);
export default __webpack_public_path__ + "static/media/ic_paystack.92d3f4274d0df068a719357176705998.svg";
export { ForwardRef as ReactComponent };